var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "tableInfo" }, [
        _c("div", { staticClass: "flex_space" }, [
          _c("span", { staticClass: "titel" }, [
            _vm._v(
              " セントラルフィールド中目黒 下水道の点検工事［20220805-A123］ "
            ),
          ]),
          _c("span", {}),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }